import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { SaveStateData } from 'dbweb-core';
import { AceEditorModule } from 'ng2-ace-editor';
import { TaskComponent } from './task.component';
import { BillModule } from '../bill/bill.module';
import { MatInputModule, MatFormFieldModule } from '@angular/material';
import { NewlinePipe } from './newline.pipe';

@NgModule({
	declarations: [TaskComponent, NewlinePipe],
	imports: [
		CommonModule,
		BillModule,
		MatExpansionModule,
		MatIconModule,
		MatInputModule,
		MatFormFieldModule,
		AceEditorModule,
		RouterModule,
		RouterModule.forChild([
			{
				path: '**',
				component: TaskComponent,
				data: SaveStateData
			}
		])
	]
})
export class TaskModule {}
